import { version } from '../../package.json';
export default version;
//# sourceMappingURL=index.js.map



//////////////////
// WEBPACK FOOTER
// ../~/_antd@3.23.4@antd/es/version/index.js
// module id = 865
// module chunks = 0